import { useState, useEffect } from "react";
import { IoCheckmarkDoneSharp, IoCloseSharp, IoTrash } from "react-icons/io5";
import ImgBellNotification from "src/assets/images/bellnotification.gif";
import SkeletonGeneralCard from "../Shared/Skeletons/SkeletonGeneralCard";
import { classNames, dateToLocal, dateToLocalHour } from "src/helpers/mixins";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import APIService from "src/services/Api";
import { ImSpinner9 } from "react-icons/im";
import { INotification } from "src/types";
import { useAppStateContext } from "src/auth/AppStateContext";
import { isMobileDevice } from "src/helpers/animationUtils";

type ParamsNotiUB = {
  close(): void;
};
type TypeLoadingDel = {
  id: number | string;
  loading: boolean;
};

const NotificationUserBody: React.FC<ParamsNotiUB> = ({ close }) => {
  const navigate = useNavigate();
  const [animateClose, setAnimateClose] = useState<boolean>(false);
  const [loadingDel, setLoadingDel] = useState<TypeLoadingDel>({ id: "", loading: false });
  const [notifications, setNotifications] = useState<INotification[]>([]);
  const { notifications: notification } = useAppStateContext();
  const [animationDelete, setAnimationDelete] = useState<string | number>("-");
  const isMobile = isMobileDevice()
  const handleClose = () => {
    setAnimateClose(true);
    window.setTimeout(() => {
      close();
    }, isMobile ? 200 : 500); // Reducir tiempo en móvil
  };
  useEffect(() => {
    if (notification !== notifications) {
      setNotifications(notification);
    }
  }, [notification]);

  const handleRemove = async (id: string | number) => {
    setLoadingDel({ id, loading: true });
    const del = await APIService.userNotificationDelete({ id });
    console.log(del);
    if (del.data.data.del.affected === 1) {
      setAnimationDelete(id);
      setNotifications(notifications.filter((e) => e.id !== id));
    } else {
      alert("no fue posible eliminar");
    }
    setLoadingDel({ id, loading: false });
  };
  /*const markAsRead = async(id:any) => {
     await APIService.userNotificationRead({id})
    if(!notifications.find(n => n.id === id)?.seen){
      setNotifications(notifications.map(e => {
        if(e.id === id){
          e.seen = true
        }
        return e
      }))
    } 
  }*/
  const handleNavigate = async (link: string, id: any) => {
    //markAsRead(id)
    handleClose();
    navigate(link);
  };

  return (
    <div>
      <div className="sidebar-notification-user opensans">
        <div className={classNames("opacity-before", animateClose ? "fadeout" : "fadein")}></div>
        <div
          className={classNames(`content-notification-user bg-white`, animateClose ? `forwardleft` : `forwardright`)}
        >
          <div className="bg-white text-base font-normal flex items-center gap-4 py-4 px-6  border-b border-stone-400 shadow-md">
            <div className={`flex items-center gap-2 ${isMobile ? 'fadeintop' : 'fadeintop'}`}>
              <img src={ImgBellNotification} className="w-14" alt="Notificacion" />
              Notificaciones
            </div>
            <IoCloseSharp onClick={() => handleClose()} className="cursor-pointer" size={33} />
          </div>
          <div className="px-0 pt-0 pb-4 bg-stone-100">
            <SkeletonGeneralCard
              loading={false}
              heightClass={"h-52"}
              arrayItems={8}
              mtClass="mt-0"
              className={"grid grid-cols-1 gap-4"}
            >
              <section className="overflow-x-auto" style={{ maxHeight: "85vh" }}>
                {notifications.length === 0 && (
                  <div className="bg-white rounded-md shadow-sm px-4 py-2 notification-minicard mb-3">
                    <div className="noti-minc-header  text-stone-700">Actualmente no hay notificaciones pendientes</div>
                    <div className="text-sm" style={{ lineHeight: "24px" }}>
                      Cuando haya algún movimiento mensajes, clases, te avisaremos
                      inmediatamente.
                    </div>
                  </div>
                )}
                <div className="px-4 py-2">
                  {notifications.map((n, key) => (
                    <div
                      key={key.toString()}
                      className={classNames(
                        animationDelete === n.id ? (isMobile ? "" : "fadeout") : "",
                        n.seen ? "" : "border border-sky-300 ",
                        " bg-white rounded-md w-full pt-2 notification-minicard mb-4 border  border-stone-200 text-sm"
                      )}
                    >
                      <div className="flex items-center text-black px-4 gap-4">
                        <div className="text-xs w-fit rounded-md text-stone-700">
                          {moment(new Date()).format("YYYY-MM-DD") !== dateToLocal(n.createdAt) ? (
                            <>{dateToLocal(n.createdAt)} </>
                          ) : (
                            <span className={classNames(n?.seen ? " " : "bg-yellow-400", "px-1 py-1 rounded-md")}>
                              Hoy
                            </span>
                          )}
                          <span className="text-xs font-normal"> {dateToLocalHour(n.createdAt)}</span>
                        </div>
                        {n.seen && <IoCheckmarkDoneSharp size={17} className="text-sky-500" />}
                      </div>
                      
                      <div className="noti-minc-header px-4 pt-2 text-black">
                        <span  dangerouslySetInnerHTML={{ __html: n.message }} />
                      </div>

                      <div className="flex items-center px-4 mb-2 gap-4 mt-2">
                        {(n?.link?.length || 0) > 0 && (
                          <button
                            onClick={() => handleNavigate(n.link, n.id)}
                            className="bg-stone-200 px-1 cursor-pointer text-black text-xs rounded-sm py-1"
                          >
                            Leer Más
                          </button>
                        )}

                        <div
                          onClick={() =>
                            loadingDel.id === n.id && loadingDel.loading ? undefined : handleRemove(n.id)
                          }
                          className="bg-stone-200 px-1 cursor-pointer text-black rounded-xs py-1 "
                        >
                          {loadingDel.id === n.id && loadingDel.loading ? (
                            <div className="flex items-center gap-2">
                              Cargando.. <ImSpinner9 className="text-rose-400 animate-spin" />
                            </div>
                          ) : (
                            <IoTrash size={20} />
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="w-full mb-52"></div>
              </section>
            </SkeletonGeneralCard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationUserBody;
